import {NgModule, ModuleWithProviders} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IGoldenLayoutConfiguration, GoldenLayoutConfiguration} from './src/config';
import {GoldenLayoutService} from './src/golden-layout.service';
import {GoldenLayoutComponent} from './src/golden-layout.component';

export {IComponentConfiguration,IGoldenLayoutConfiguration,GoldenLayoutConfiguration} from './src/config'; 
export {GlOnInit,GlOnResize} from './src/hooks';
export {IComponentInitCallback,IComponentInitCallbackFactory,GoldenLayoutService} from './src/golden-layout.service';
export {GoldenLayoutComponent} from './src/golden-layout.component';
export class GoldenLayoutModule {
/**
 * @param {?} config
 * @return {?}
 */
static forRoot(config: IGoldenLayoutConfiguration): ModuleWithProviders {
        return {
            ngModule : GoldenLayoutModule,
            providers : [
                GoldenLayoutService,
                {provide : GoldenLayoutConfiguration, useValue : config}
            ]
        };
    }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports : [CommonModule],
    exports : [GoldenLayoutComponent],
    declarations : [GoldenLayoutComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function GoldenLayoutModule_tsickle_Closure_declarations() {
/** @type {?} */
GoldenLayoutModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
GoldenLayoutModule.ctorParameters;
}



interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
